import { createFileRoute } from '@tanstack/react-router'
import { CommunityPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/communaute/')({
  loader: () => loadPageData({ data: { kind: 'community', locale: 'fr' } }),
  head: () => staticRouteHead('community', 'fr'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <CommunityPage />
    </CatalogProvider>
  )
}
